import React from "react";
import { AuthProvider } from "oidc-react";

const Test = () => {
	const oidcConfig = {
		onSignIn: async (user) => {
			console.log(user?.profile);
			console.log(user);
			localStorage.setItem("stUser", JSON.stringify(user?.profile));
			window.location.assign("/");
		},
		onSignOut: async (user) => {
			console.log("signed-out");
		},
		authority: process.env.REACT_APP_AUTHORITY,
		clientId: process.env.REACT_APP_CLIENT_ID,
		clientSecret: process.env.REACT_APP_CLIENT_SECRET,
		scope: process.env.REACT_APP_SCOPE,
		redirectUri: process.env.REACT_APP_REDIRECT_URL,
		responseType: process.env.REACT_APP_RESPONSE_TYPE,
		// clientId:
		// 	"1066073673387-undfdseanu1soilcdprq1p4m8gq8a1iu.apps.googleusercontent.com",
		// authority: "https://accounts.google.com",
	};

	return (
		<>
			<AuthProvider {...oidcConfig}>
				<div>....</div>
				{/* <button onClick={() => void auth.signinRedirect()}>Log in</button>; */}
				{/* <button onClick={() => handleLogOut()}>logout</button> */}
			</AuthProvider>
		</>
	);
};

export default Test;
